import { useMemo } from 'react';

import {
  type TableNamesWithCustomColumns,
  type TableNamesWithExtrasMenu,
  type TableNamesWithManagedByAutoneToggle,
  type TableNamesWithMatchSystemRecommendationToggle,
  useAssortmentSessionStorageAtom,
} from '../storage/session-storage';

export const useExtrasMenuTypeGuards = (
  tableName: TableNamesWithExtrasMenu,
) => {
  const sessionStorageKey = `${tableName}.extrasMenu` as const;
  const [extrasMenuAtom] = useAssortmentSessionStorageAtom(sessionStorageKey);

  const typeGuards = useMemo(
    () => ({
      isTableWithCustomColumns: (
        _tableName: TableNamesWithExtrasMenu,
      ): _tableName is TableNamesWithCustomColumns =>
        'customColumns' in extrasMenuAtom,
      isTableWithManagedByAutoneToggle: (
        _tableName: TableNamesWithExtrasMenu,
      ): _tableName is TableNamesWithManagedByAutoneToggle =>
        'managedByAutoneToggle' in extrasMenuAtom,
      isTableWithMatchSystemRecommendationToggle: (
        _tableName: TableNamesWithExtrasMenu,
      ): _tableName is TableNamesWithMatchSystemRecommendationToggle =>
        'matchSystemRecommendationToggle' in extrasMenuAtom,
    }),
    [extrasMenuAtom],
  );

  return typeGuards;
};
